module.exports = __webpack_public_path__ + "img/loadingPage.0c81ad12.gif";